import defaultDayjs from "dayjs";

import {
  DateValidationProps,
  LookupValidation,
  Validation,
  ValidationProps,
} from "@/types/validation";

const maxDate = defaultDayjs().add(-12, "year");
const minDate = defaultDayjs().add(-120, "year");

const firstNameValidation: ValidationProps = {
  regex: /^(?=.{2,})([A-Za-z]{1,15})([ '-][A-Za-z]{1,15}){0,2}$/,
  message:
    "First name must consist of 2-15 letters and cannot start or end with a space",
};
const lastNameValidation: ValidationProps = {
  regex: /^(?=.{2,})([A-Za-z]{1,15})([ '-][A-Za-z]{1,15}){0,2}$/,
  message:
    "Last name must consist of 2-15 letters and cannot start or end with a space",
};
const birthdateValidation: DateValidationProps = {
  regex: /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{4}$/,
  message: `Birthdate must be in a valid range (${minDate.format(
    "MM/DD/YYYY"
  )}-${maxDate.format("MM/DD/YYYY")}).`,
  maxDate,
  minDate,
};
const zipValidation: ValidationProps = {
  regex: /^[a-z0-9][a-z0-9\- ]{0,10}[a-z0-9]$/gim,
  message: "Zip code must be in a valid format",
};

export const lookupValidation: Validation<LookupValidation> = {
  birthdate: [birthdateValidation],
  firstName: [firstNameValidation],
  lastName: [lastNameValidation],
  zip: [zipValidation],
};
